import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Grid, GridItem } from '@chakra-ui/react';
import { updateOKR } from 'components/RabbitOKRCreationPanel/OKRCreationPanelSlice';
import { updateLocalStateValues } from 'components/RabbitOKRSidePanel/KRslice';
import { OKRDescriptionComponent } from 'components/RabbitOKRSidePanel/PrimaryPanel/Sections/Details/OKRDescription';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { kRDrawerSelector } from 'selectors/kRDrawer';
import { okrCreationPanelStateSelector } from 'selectors/okrCreationPanelSelector';

import { TextLabel } from 'uiToolkitV1/Typography';

interface Props {
  isLeftIcon?: boolean;
  isEditOKR?: boolean;
  setIsErrorInForm: React.Dispatch<React.SetStateAction<boolean>>;
}

const DescriptionSection = ({ isEditOKR, isLeftIcon = false, setIsErrorInForm }: Props) => {
  const dispatch = useDispatch();
  const createOKRDetails = useSelector(okrCreationPanelStateSelector);
  const editOKRSavedDetails = useSelector(kRDrawerSelector);
  const editOKRDetails = useMemo(
    () => ({ ...editOKRSavedDetails, ...editOKRSavedDetails.localStateValues }),
    [editOKRSavedDetails]
  );
  const okrDetails = isEditOKR ? editOKRDetails : createOKRDetails;

  const { description } = okrDetails;
  const [error, setError] = useState('');

  useEffect(() => {
    setIsErrorInForm(!!error);
  }, [error, setIsErrorInForm]);

  const onChange = useCallback(
    (updates) => {
      dispatch(isEditOKR ? updateLocalStateValues(updates) : updateOKR(updates));
    },
    [dispatch, isEditOKR]
  );

  return (
    // @ts-expect-error: union too complex
    <Grid gridTemplateColumns="16% 4% 79%" alignItems="flex-start">
      <GridItem mt="6px">
        <TextLabel color="text.g2">Description:</TextLabel>
      </GridItem>
      {/* For spacing after first column */}
      <GridItem />
      <GridItem
        sx={{
          '.okr-description': {
            paddingTop: '0px !important',
          },
        }}
      >
        <OKRDescriptionComponent
          description={description}
          // @ts-expect-error: params type mismatch
          onChangeWithoutBlur={(newDescription: string) => onChange({ description: newDescription })}
          isReadOnly={false}
          error={error}
          // @ts-ignore
          setError={setError}
          isLeftIcon={isLeftIcon}
        />
      </GridItem>
    </Grid>
  );
};

export { DescriptionSection };
